export const limitsChange = {
    allowZeroLimits: true,
    enforceZeroPrecision: true,
    validations: {
        INTERNET: {
            biggerThanPOS: true,
        },
    },
};
